/*
*###############################################################################
*Module Name                   : DPDropDown.js                                 #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  Dinisuru Balasuriya                          #
*Date                          : Sunday, January 22nd 2023, 12:07:36 pm        #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useEffect, useRef, useState } from 'react';

import { Row, Label, Input } from "reactstrap"
import "../../assets/scss/dropdown.scss"


const DPDropDown = ({ rowClass, selectedGroup, optionGroup, onChange, labelText,
    disabled, labelHide, id, inputId, iconShow, impactColor, padding, width, colWidth = 3 }) => {

    const [isOpen, setIsOpen] = useState(false); //state for the dropdown
    const [searchValue, setSearchValue] = useState(''); //state for the search input
    const [focusedItem, setFocusedItem] = useState(0); //state for the focused item in the dropdown

    const buttonRef = useRef(null); //reference for the dropdown button
    const dropdownRef = useRef(null); //reference for the dropdown
    const inputRef = useRef(null); //reference for the search input

    let color = "#FFFFFF"
    let icon = ""
    if (impactColor == '+') {
        color = "#0FFF00"
        icon = "mdi mdi-plus"
    } else if (impactColor == '-') {
        color = "#FF0000"
        icon = "mdi mdi-minus"
    } else {
        color = "#FFFFFF"
        icon = ""
    }

    const arrowIcon = isOpen ? "mdi mdi-chevron-up" : "mdi mdi-chevron-down";

    function search(selectedGroup, optionGroup) { //function to search the selected option and return the label to display
        for (var i = 0; i < optionGroup.length; i++) {
            if (optionGroup[i].value == selectedGroup) {
                return optionGroup[i]["label"];
            }
        }
    }


    const toggleDropdown = () => { //function to toggle the dropdown open/close
        setIsOpen((prev) => !prev);
    }


    useEffect(() => { //useEffect to set the width of the dropdown to the width of the button
        if (buttonRef.current && dropdownRef.current && isOpen) {
            dropdownRef.current.style.width = `${buttonRef.current.offsetWidth}px`;
        }

        if (inputRef.current && isOpen) { //set focus to the search input when the dropdown is opened
            inputRef.current.focus();
        }

        setSearchValue('')
        setFocusedItem(0)
    }, [isOpen])


    useEffect(() => { //useEffect to close the dropdown when clicked outside
        const handleClickOutside = event => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) && inputRef.current && !inputRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef, inputRef]);


    //filter the options based on the search input 
    const filteredOptions = optionGroup.filter(option =>
        option.label.toLowerCase().includes(searchValue.toLowerCase()) ||
        option.value.toString().toLowerCase().includes(searchValue.toLowerCase())
    );

    const handleSearchChange = event => { //function to handle the search input change
        setSearchValue(event.target.value);
        setFocusedItem(0)
    };

    const handleKeyPress = (event) => {
        if (event.key === 'ArrowUp') {
            if (focusedItem > 0) {
                setFocusedItem(focusedItem - 1);
                scrollDropdown(-1);
            }
        } else if (event.key === 'ArrowDown') {
            if (focusedItem < filteredOptions.length - 1) {
                setFocusedItem(focusedItem + 1);
                scrollDropdown(1);
            }
        } else if (event.key === 'Enter') {
            if (filteredOptions.length > 0) {
                onChange(filteredOptions[focusedItem]);
                setIsOpen(false);
            }
        }
    };

    const scrollDropdown = (direction) => {
        const dropdownContainer = dropdownRef.current;

        if (dropdownContainer) {
            const newIndex = focusedItem + direction;

            if (newIndex >= 0 && newIndex < filteredOptions.length) {
                setFocusedItem(newIndex);

                const selectedItem = dropdownContainer.querySelector(`li:nth-child(${newIndex + 1})`);

                if (selectedItem) {
                    const itemOffset = selectedItem.offsetTop;
                    const dropdownHeight = dropdownContainer.clientHeight;

                    if (itemOffset < dropdownContainer.scrollTop) {
                        dropdownContainer.scrollTop = itemOffset;
                    } else if (itemOffset + selectedItem.clientHeight > dropdownContainer.scrollTop + dropdownHeight) {
                        dropdownContainer.scrollTop = itemOffset + selectedItem.clientHeight - dropdownHeight;
                    }
                }
            }
        }
    };

    return (
        <Row className={rowClass}>
            {labelHide ? null : <Label
                htmlFor="example-text-input"
                className={`col-md-${colWidth} col-form-label-sm`}
            >
                {labelText}&nbsp;
                {iconShow ? (<i className={icon} style={{ fontSize: '12px', color: color }}></i>) : null}
            </Label>}
            <div className={labelHide ? "col-md-12 " + padding ? padding : "" : `col-md-${12 - colWidth}`} >

                <div style={{ position: "relative", width: "100%", display: "inline-block" }}>
                    <input
                        type="button"
                        className="form-control-sm border-1"
                        style={{
                            border: "solid #ccc",
                            width: width ? width : "100%",
                            textAlign: "left",
                            background: '#FFFFFF',
                            marginRight: "20px"
                        }}
                        value={selectedGroup ? search(`${selectedGroup}`, optionGroup) : 'Select Here..'}
                        onClick={toggleDropdown}
                        ref={buttonRef}
                        id={id}
                        disabled={disabled}
                    //onKeyPress={handleKeyPress}
                    />
                    <i className={arrowIcon} onClick={(e) => {
                        //prevent parent click event

                        e.stopPropagation();
                        if (!disabled) {
                            toggleDropdown()
                        }
                    }} style={{ position: "absolute", right: "7px", top: "50%", transform: "translateY(-50%)", fontSize: "20px", cursor: 'pointer' }} />
                </div>

                {isOpen && (
                    <div className='form-control-sm border-1 p-0' style={{ border: "solid #ccc", background: '#FFFFFF', position: 'absolute ', zIndex: 99, overflow: 'auto' }}>
                        <input
                            ref={inputRef}
                            className="form-control-sm border-1"
                            style={{ border: "solid #ccc", width: '100%', textAlign: "left", background: '#FFFFFF' }}
                            value={searchValue}
                            onChange={handleSearchChange}
                            placeholder="Search..."
                            id='search'
                            onKeyDown={handleKeyPress}
                        />
                        <ul ref={dropdownRef} className={`dropdown form-control-sm ${isOpen ? 'open' : ''} p-0`} style={{ overflowY: 'auto', maxHeight: "150px", background: '#FFFFFF' }}>

                            {filteredOptions.map((option, index) => (
                                <li key={index}
                                    className={`dropdown-item ${focusedItem === index ? ' focused-li' : ''} `}
                                    //className={`dropdown-item actve} `}
                                    // className="dropdown"
                                    style={{ paddingLeft: 5, margin: '5px', listStyleType: 'none', fontWeight: "inherit", fontSize: "12px", fontFamily: "inherit", cursor: "pointer" }}
                                    onClick={() => {
                                        onChange(option)
                                        setIsOpen(false)
                                    }}
                                >{option.label}</li>
                            ))}

                        </ul>
                    </div>
                )}
            </div>
        </Row>

    );
}

export default DPDropDown;
